import { render } from "./ProjectView.vue?vue&type=template&id=57b19d40&scoped=true&ts=true"
import script from "./ProjectView.vue?vue&type=script&lang=ts"
export * from "./ProjectView.vue?vue&type=script&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=57b19d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b19d40"]])

export default __exports__